//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { darkThemeStyles } from "../utils/google-maps";

export default {

	name: "hub-google-map",

	props: {

		latitude: {
			default: 0,
			required: true,
			type: Number
		},

		longitude: {
			default: 0,
			required: true,
			type: Number
		},

		zoom: {
			default: 16,
			required: false,
			type: Number
		}

	},

	data()
	{
		return {
			googleMap: null,
			theme: "default"
		};
	},

	mounted()
	{
		this.prepareGoogleMap();

		this.theme = document.body.dataset.theme || "default";
		Latte.action.on("latte:switch-theme", ({themeId}) => this.theme = themeId);
	},

	computed: {},

	methods: {

		prepareGoogleMap()
		{
			const mapOptions = {
				center: new google.maps.LatLng(this.latitude, this.longitude),
				zoom: this.zoom,
				disableDefaultUI: true,
				gestureHandling: "none",
				zoomControl: false
			};

			if (this.theme === "dark")
				mapOptions.styles = darkThemeStyles;

			this.googleMap = new google.maps.Map(this.$el, mapOptions);

			this.prepareMarker();
		},

		prepareMarker()
		{
			new google.maps.Marker({
				map: this.googleMap,
				position: new google.maps.LatLng(this.latitude, this.longitude)
			});
		}

	},

	watch: {

		latitude()
		{
			this.googleMap.panTo(new google.maps.LatLng(this.latitude, this.longitude));
		},

		longitude()
		{
			this.googleMap.panTo(new google.maps.LatLng(this.latitude, this.longitude));
		},

		zoom()
		{
			this.googleMap.setZoom(this.zoom);
		},

		theme()
		{
			this.prepareGoogleMap();
		}

	}

}

